import React, { useEffect } from "react";
import { propOr, head } from "ramda";
import { isNilOrEmpty } from "src/main_app/utils/common";
import { useTenantConfig, useUserPermissions, checkPermission } from "src/main_app/actions";
import { getCustomersDataLogin } from "src/main_app/services/apis";
import { authService } from "../../../base/services";

const HomePage = () => {

  const tenantConfig = useTenantConfig()
  const userPermissions = useUserPermissions();
  const user = authService.getUser();
  const customerLogin = async (data) => {
    const response = await getCustomersDataLogin(data)
    const customerId = propOr([], 'data', response);
    document.location.href = `customer/${customerId}/usage`;
  }

  // Function to filter menu items based on user permissions
  const getAccessibleMenus = (subMenus) => {
    let results = subMenus;
    
    // Filter out menus based on permissions (same logic as header.jsx)
    if (!checkPermission(userPermissions, "customers-page", "canView")) {
      results = results.filter((item) => item.to !== "/customers");
    }
    if (!checkPermission(userPermissions, "alerts-page", "canView")) {
      results = results.filter((item) => item.to !== "/alerts");
    }
    if (!checkPermission(userPermissions, "industry-page", "canView")) {
      results = results.filter((item) => item.to !== "/industry");
    }
    if (!checkPermission(userPermissions, "map-page", "canView")) {
      results = results.filter((item) => item.to !== "/map");
    }
    if (!checkPermission(userPermissions, "dashboard-page", "canView")) {
      results = results.filter((item) => item.to !== "/dashboard");
    }
    if (!checkPermission(userPermissions, "dashboard-page", "canView")) {
      results = results.filter((item) => item.to !== "/pressure");
    }
    if (!checkPermission(userPermissions, "insights-page", "canView")) {
      if (tenantConfig.slug == "hunterwater") {
        results = results.filter(
          (item) => item.to !== "/insights/data-validation"
        );
      } else {
        results = results.filter((item) => item.to !== "/insights");
      }
    }
    if (!checkPermission(userPermissions, "report-page", "canView")) {
      results = results.filter((item) => item.to !== "/report");
    }
    
    return results;
  };

  useEffect(() => {
    if (isNilOrEmpty(tenantConfig) || userPermissions.length === 0) return;
    
    const subMenus = propOr([], "subMenus", tenantConfig);
    
    if (user.role == 'Customer') {
      customerLogin(user);
    } else {
      // If pathLandingPage is configured, use it
      if (tenantConfig.pathLandingPage) {
        document.location.href = tenantConfig.pathLandingPage;
        return;
      }

      // Get accessible menus based on user permissions
      const accessibleMenus = getAccessibleMenus(subMenus);
      
      // Find the default menu among accessible menus, or use the first accessible menu
      let targetMenu = accessibleMenus.find((i) => i.default);
      if (!targetMenu && accessibleMenus.length > 0) {
        targetMenu = head(accessibleMenus);
      }
      
      // Redirect to the target menu or fallback to root
      const redirectPath = targetMenu ? propOr("/", "to", targetMenu) : "/";
      document.location.href = redirectPath;
    }
  }, [tenantConfig, userPermissions]);

  return <div className="the-content"></div>;
};

export default HomePage;
